import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { login } from '../../store/slices/authSlice';
import { useDispatch } from 'react-redux';
import './SignIn.css';
import '../signUp/SignUp.css';

const numberOnlyRegex = new RegExp(/^[0-9]+$/);

const signInSchema = yup.object().shape(
    {
        mobileNumber: yup.string().when('email', {
            is: '',
            then: yup.string().required('Please enter email or mobile number.').matches(numberOnlyRegex, 'Mobile number must contiain numbers only.'),
            otherwise: yup.string(),
        }),
        email: yup.string().when('mobileNumber', {
            is: '',
            then: yup.string().required('Please enter email or mobile number.'),
            otherwise: yup.string(),
        }),
        password: yup.string().required('Please enter password.'),
    },
    ['email', 'mobileNumber']
);

const SignIn = () => {
    const dispatch = useDispatch();
    const [showPassword, setShowPassword] = useState(false);
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(signInSchema),
    });

    const togglePasswordHandler = () => {
        setShowPassword((prev) => !prev);
    };

    const submitHandler = (submittedData) => {
        if (submittedData?.email?.length === 0) {
            delete submittedData.email;
        }
        if (submittedData?.mobileNumber?.length === 0) {
            delete submittedData.mobileNumber;
        }
        dispatch(login(submittedData));
    };

    return (
        <div className="form-wrapper signin">
            <form onSubmit={handleSubmit(submitHandler)}>
                <div className="inner-form-wrap">
                    <div className="form-block">
                        <label>Mobile number</label>
                        <input {...register('mobileNumber')} type="text" placeholder="mobile Number" className="form-control" />
                        {errors.mobileNumber && <span className="error-msg">{errors.mobileNumber.message}</span>}
                    </div>
                    <div className="form-block">
                        <label>email</label>
                        <input {...register('email')} type="text" placeholder="Email" className="form-control" />
                        {errors.email && <span className="error-msg">{errors.email.message}</span>}
                    </div>
                    <div className="form-block eye-field">
                        <label>password*</label>
                        <div className="passwrd-block">
                            <input
                                {...register('password')}
                                type={showPassword ? 'text' : 'password'}
                                placeholder="Password"
                                className="form-control"
                            />
                            <i
                                className={`icon-eye ${showPassword ? 'active' : ''}`}
                                style={{ cursor: 'pointer' }}
                                onClick={togglePasswordHandler}
                            ></i>
                        </div>
                        {errors.password && <span className="error-msg">{errors.password.message}</span>}
                    </div>
                    <button type="submit" className="btn-main">
                        Sign In
                    </button>
                </div>
            </form>
        </div>
    );
};

export default SignIn;
